import type { EmitEvent } from "@/domains/core"
import { useRef } from "react"

import { EventEmitter } from "@/domains/library"

// Singleton instance
let singleton: EventEmitter<EmitEvent> | null = null

function useEventEmitter(): EventEmitter<EmitEvent> {
  if (!singleton) {
    singleton = new EventEmitter<EmitEvent>()
  }

  const eventEmitterRef = useRef(singleton)

  return eventEmitterRef.current
}

export default useEventEmitter
